import { render, staticRenderFns } from "./Fintech.vue?vue&type=template&id=7d8a34ce&"
import script from "./Fintech.vue?vue&type=script&lang=js&"
export * from "./Fintech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports